import React, { useState } from 'react';
import { LegalModal } from './LegalModal';
export function Footer() {
  const [privacyOpen, setPrivacyOpen] = useState(false);
  const [termsOpen, setTermsOpen] = useState(false);
  return <>
      <footer id="contact" className="bg-avm-footer border-t border-avm-accent/30 pt-24 pb-12 px-6 md:px-12" data-id="element-28">
        <div className="max-w-7xl mx-auto" data-id="element-29">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-16 mb-24" data-id="element-30">
            <div data-id="element-31">
              <img src="https://cdn.magicpatterns.com/uploads/1Wt6xZ2CEnACLmcpPMDgdq/pasted-image.jpg" alt="AVM Logo" className="h-12 object-contain logo-blend opacity-90 mb-8" data-id="element-32" />
              <h4 className="font-serif text-2xl text-avm-text mb-4" data-id="element-33">
                Atlas Ventures Management LLC
              </h4>
              <p className="text-avm-textMuted font-light max-w-sm" data-id="element-34">
                Building and operating technology-first businesses within
                traditional industries.
              </p>
            </div>

            <div className="flex flex-col md:items-end justify-center" data-id="element-35">
              <span className="text-avm-textMuted text-sm font-medium tracking-widest uppercase mb-4 block" data-id="element-36">
                Get in Touch
              </span>
              <a href="mailto:hello@atlasvmgmt.com" className="font-serif text-3xl md:text-4xl text-avm-text hover:text-avm-accent transition-colors duration-300 border-b border-avm-accent/30 hover:border-avm-accent pb-2" data-id="element-37">
                hello@atlasvmgmt.com
              </a>
            </div>
          </div>

          <div className="flex flex-col md:flex-row justify-between items-center pt-8 border-t border-avm-border text-xs text-avm-textMuted/60 font-medium tracking-wide" data-id="element-38">
            <p data-id="element-39">© 2026 Atlas Ventures Management LLC. All rights reserved.</p>
            <div className="flex gap-6 mt-4 md:mt-0" data-id="element-40">
              <button onClick={() => setPrivacyOpen(true)} className="hover:text-avm-text transition-colors" data-id="element-41">
                Privacy Policy
              </button>
              <button onClick={() => setTermsOpen(true)} className="hover:text-avm-text transition-colors" data-id="element-42">
                Terms of Service
              </button>
            </div>
          </div>
        </div>
      </footer>

      <LegalModal isOpen={privacyOpen} onClose={() => setPrivacyOpen(false)} title="Privacy Policy" data-id="element-43">
        <p className="text-avm-text font-medium text-base" data-id="element-44">
          Effective Date: January 1, 2026
        </p>

        <p data-id="element-45">
          Atlas Ventures Management LLC ("AVM," "we," "us," or "our") respects
          your privacy and is committed to protecting the personal information
          you share with us. This Privacy Policy explains how we collect, use,
          and safeguard information when you visit our website.
        </p>

        <div className="space-y-4" data-id="element-46">
          <h3 className="text-avm-text font-medium text-base" data-id="element-47">
            1. Information We Collect
          </h3>
          <p data-id="element-48">
            We may collect limited personal information when you voluntarily
            contact us via email, including your name, email address, and the
            content of your correspondence. We do not use cookies for tracking
            purposes or collect data through automated means beyond standard
            server logs.
          </p>
        </div>

        <div className="space-y-4" data-id="element-49">
          <h3 className="text-avm-text font-medium text-base" data-id="element-50">
            2. How We Use Your Information
          </h3>
          <p data-id="element-51">
            Any information collected is used solely to respond to your
            inquiries, provide requested services, and improve our operations.
            We do not sell, rent, or share your personal information with third
            parties for marketing purposes.
          </p>
        </div>

        <div className="space-y-4" data-id="element-52">
          <h3 className="text-avm-text font-medium text-base" data-id="element-53">
            3. Data Security
          </h3>
          <p data-id="element-54">
            We implement reasonable administrative, technical, and physical
            safeguards to protect your personal information from unauthorized
            access, disclosure, alteration, or destruction. However, no method
            of transmission over the Internet is 100% secure.
          </p>
        </div>

        <div className="space-y-4" data-id="element-55">
          <h3 className="text-avm-text font-medium text-base" data-id="element-56">
            4. Third-Party Links
          </h3>
          <p data-id="element-57">
            Our website may contain links to third-party websites. We are not
            responsible for the privacy practices or content of those sites. We
            encourage you to review the privacy policies of any third-party
            sites you visit.
          </p>
        </div>

        <div className="space-y-4" data-id="element-58">
          <h3 className="text-avm-text font-medium text-base" data-id="element-59">
            5. Changes to This Policy
          </h3>
          <p data-id="element-60">
            We may update this Privacy Policy from time to time. Any changes
            will be posted on this page with an updated effective date. Your
            continued use of our website constitutes acceptance of the revised
            policy.
          </p>
        </div>

        <div className="space-y-4" data-id="element-61">
          <h3 className="text-avm-text font-medium text-base" data-id="element-62">6. Contact Us</h3>
          <p data-id="element-63">
            If you have questions about this Privacy Policy, please contact us
            at{' '}
            <a href="mailto:hello@atlasvmgmt.com" className="text-avm-accent hover:text-avm-text transition-colors border-b border-avm-accent/30" data-id="element-64">
              hello@atlasvmgmt.com
            </a>
            .
          </p>
        </div>
      </LegalModal>

      <LegalModal isOpen={termsOpen} onClose={() => setTermsOpen(false)} title="Terms of Service" data-id="element-65">
        <p className="text-avm-text font-medium text-base" data-id="element-66">
          Effective Date: January 1, 2026
        </p>

        <p data-id="element-67">
          Welcome to the website of Atlas Ventures Management LLC ("AVM," "we,"
          "us," or "our"). By accessing or using this website, you agree to be
          bound by these Terms of Service. If you do not agree, please do not
          use this website.
        </p>

        <div className="space-y-4" data-id="element-68">
          <h3 className="text-avm-text font-medium text-base" data-id="element-69">
            1. Use of Website
          </h3>
          <p data-id="element-70">
            This website is provided for informational purposes only. The
            content on this site does not constitute investment advice,
            financial advice, legal advice, or any other form of professional
            advice. You should consult with appropriate professionals before
            making any business or investment decisions.
          </p>
        </div>

        <div className="space-y-4" data-id="element-71">
          <h3 className="text-avm-text font-medium text-base" data-id="element-72">
            2. Intellectual Property
          </h3>
          <p data-id="element-73">
            All content on this website — including text, graphics, logos,
            images, and software — is the property of Atlas Ventures Management
            LLC or its licensors and is protected by applicable intellectual
            property laws. You may not reproduce, distribute, or create
            derivative works without our prior written consent.
          </p>
        </div>

        <div className="space-y-4" data-id="element-74">
          <h3 className="text-avm-text font-medium text-base" data-id="element-75">
            3. No Warranties
          </h3>
          <p data-id="element-76">
            This website and its content are provided "as is" and "as available"
            without warranties of any kind, either express or implied. AVM does
            not warrant that the website will be uninterrupted, error-free, or
            free of viruses or other harmful components.
          </p>
        </div>

        <div className="space-y-4" data-id="element-77">
          <h3 className="text-avm-text font-medium text-base" data-id="element-78">
            4. Limitation of Liability
          </h3>
          <p data-id="element-79">
            To the fullest extent permitted by law, AVM shall not be liable for
            any direct, indirect, incidental, consequential, or punitive damages
            arising from your use of or inability to use this website, even if
            we have been advised of the possibility of such damages.
          </p>
        </div>

        <div className="space-y-4" data-id="element-80">
          <h3 className="text-avm-text font-medium text-base" data-id="element-81">
            5. External Links
          </h3>
          <p data-id="element-82">
            This website may contain links to third-party websites. These links
            are provided for convenience only and do not imply endorsement. AVM
            is not responsible for the content or practices of linked sites.
          </p>
        </div>

        <div className="space-y-4" data-id="element-83">
          <h3 className="text-avm-text font-medium text-base" data-id="element-84">
            6. Governing Law
          </h3>
          <p data-id="element-85">
            These Terms of Service shall be governed by and construed in
            accordance with the laws of the State of Delaware, without regard to
            its conflict of law provisions.
          </p>
        </div>

        <div className="space-y-4" data-id="element-86">
          <h3 className="text-avm-text font-medium text-base" data-id="element-87">
            7. Changes to Terms
          </h3>
          <p data-id="element-88">
            We reserve the right to modify these Terms of Service at any time.
            Changes will be effective upon posting to this website. Your
            continued use of the website after changes are posted constitutes
            acceptance of the revised terms.
          </p>
        </div>

        <div className="space-y-4" data-id="element-89">
          <h3 className="text-avm-text font-medium text-base" data-id="element-90">8. Contact Us</h3>
          <p data-id="element-91">
            If you have questions about these Terms of Service, please contact
            us at{' '}
            <a href="mailto:hello@atlasvmgmt.com" className="text-avm-accent hover:text-avm-text transition-colors border-b border-avm-accent/30" data-id="element-92">
              hello@atlasvmgmt.com
            </a>
            .
          </p>
        </div>
      </LegalModal>
    </>;
}